import { toTitleCase } from './string';

export const getDatabaseObjectType = (str: string) => {
  if (str === 'BASE TABLE') {
    return 'Table';
  }
  return toTitleCase(str.toLowerCase());
};
